import React, { useState, useEffect } from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import { animate, motion, useScroll, useTransform } from "framer-motion";
import {
  Box,
  HStack,
  Link as ChakraLink,
  Center,
  Image,
} from "@chakra-ui/react";
import { CTK_Logo } from "../../assets";
import "./navbar.css";

const MotionImage = motion(Image);

const Navbar = () => {
  const [scrolling, setScrolling] = useState(false);
  // const { scrollY } = useScroll();

  const { scrollYProgress } = useScroll();
  const rotate = useTransform(scrollYProgress, [0, 1], [0, 360]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolling(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      const targetY = element.getBoundingClientRect().top + window.scrollY;
      
      animate(window.scrollY, targetY, {
        type: "spring",
        stiffness: 100,
        damping: 20,
        onUpdate: (value) => window.scrollTo(0, value - 75),
      });
    }
  };

  return (
    <>
      <div className="nav-logo">
        <ChakraLink className="nav-links z-50" as={ReactRouterLink} to="/">
          <MotionImage
            src={CTK_Logo}
            alt="CTK"
            boxSize={{ base: "30px", sm: "40px", lg: "60px" }}
            style={{ rotate }}
            transition={{ type: "spring", stiffness: 100, damping: 30 }}
          />
        </ChakraLink>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Box
          className={`nav-container ${scrolling ? "scrolled" : ""}`}
          boxShadow={scrolling ? "sm" : "none"}
        >
          <Center>
            <HStack spacing={{ base: "15px", sm: "40px" }}>
              <ChakraLink
                className="nav-links"
                as={ReactRouterLink}
                to="/projects"
              >
                Projects
              </ChakraLink>
              <ChakraLink
                className="nav-links"
                onClick={(e) => scrollToSection(e, "about")}
                href="#about"
              >
                About
              </ChakraLink>
              <ChakraLink
                className="nav-links"
                onClick={(e) => scrollToSection(e, "contact")}
                href="#contact"
              >
                Contact
              </ChakraLink>
            </HStack>
          </Center>
        </Box>
      </div>
    </>
  );
};

export default Navbar;
